// Neutral grey placeholder shown when a (usually external/supplier) image fails to load.
const PLACEHOLDER =
  "data:image/svg+xml;charset=utf-8," +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="400" height="300" viewBox="0 0 400 300">' +
      '<rect width="400" height="300" fill="#eef2f6"/>' +
      '<g fill="#b6c2cf"><rect x="150" y="120" width="100" height="70" rx="8"/>' +
      '<circle cx="175" cy="145" r="10"/><path d="M158 182l26-28 20 20 16-14 22 22z"/></g>' +
      "</svg>"
  );

/**
 * Global safety net for images: upgrades any http:// src to https:// and swaps a neutral
 * placeholder in when an image 404s or fails to load. Clears the "mixed content" and
 * "broken external images" SEO findings without touching every <img> in the codebase.
 * (Paired with the CSP `upgrade-insecure-requests` meta in index.html.)
 */
export function installImageSafety() {
  const fix = (img) => {
    if (!img || img.tagName !== "IMG") return;
    if (img.src && img.src.startsWith("http://")) {
      img.src = img.src.replace(/^http:\/\//i, "https://");
      return; // let it try again over https before falling back
    }
    if (img.dataset.imgFallback === "1") return;
    img.dataset.imgFallback = "1";
    img.src = PLACEHOLDER;
  };
  // capture phase so we catch load errors that don't bubble
  document.addEventListener(
    "error",
    (e) => {
      if (e.target && e.target.tagName === "IMG") fix(e.target);
    },
    true
  );
}

export { PLACEHOLDER };
